import React from "react";
import BeforeLoginRoutes from "./routes/BeforeLoginRoutes";
import ConsultantRoutes from "./routes/consultantroutes";
import { CountryProvider } from "./contexts/countrycodecontext.js";
import { UserTypeProvider } from "./contexts/usertypecontext.js";

const App = () => {
  return (
    <div>

      {/* Routes before login do NOT use these providers */}
      <BeforeLoginRoutes />

      {/* Protect Consultant area with global contexts */}
    
        <CountryProvider>
            <UserTypeProvider>
          <ConsultantRoutes />       
      </UserTypeProvider>
       </CountryProvider>

    </div>
  );
};

export default App;
